(function (doc) {
  const docEl = doc.documentElement
  const clientWidth = docEl.clientWidth

  if (!clientWidth) return

  if (clientWidth > 750) {
    docEl.style.fontSize = 10 * (clientWidth / 480) + 'px'
  } else {
    docEl.style.fontSize = 10 * (clientWidth / 360) + 'px'
  }
})(document)
